export default __webpack_public_path__ + "images/models/e44d3c400dd3334fc1119f53d760da8b.usdz";